module.exports = __webpack_public_path__ + "img/5g-area.c5595836.png";